import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { IComboOption } from '@sky-it-elections/design-system';

import HtmlWrapper from '../html-wrapper/html-wrapper';

import { IComboBoxWrapper } from './combo-box';

const ComboBoxWrapper = React.lazy(() => import('./combo-box'));

export interface IDynamicComboBox extends IComboBoxWrapper {
  children?: React.ReactNode;
  options: Array<IComboOption>;
  placeholder: string;
  value?: string;
  url?: string;
}

export const COMBO_BOX_TAG = 'ld-combo-box-widget';

const DynamicComboBox: React.FC = (props) => {
  const { children, options: optionList, value = '', placeholder, url } = props as IDynamicComboBox;

  let optionListArraified = [];
  if (typeof optionList === 'string') {
    optionListArraified = JSON.parse(optionList);
  }

  return (
    <Suspense fallback={<HtmlWrapper html={children} />}>
      <ComboBoxWrapper options={optionListArraified} value={value} placeholder={placeholder} url={url} />
    </Suspense>
  );
};

DynamicComboBox.propTypes = {
  options: PropTypes.arrayOf<IComboOption>(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    }).isRequired
  ).isRequired,
  placeholder: PropTypes.string.isRequired,
  url: PropTypes.string,
  value: PropTypes.string,
};

DynamicComboBox.defaultProps = {
  // children: null,
  value: '',
  url: '',
};

export default DynamicComboBox;
